export default function ($http) {
    return function (pageNumber, filterCriteria) {
        return $http({
            method: 'GET',
            url: 'api/vmcaccount/listbynumber',
            headers: {
                'Content-Type': 'application/json'
            },
            params: {
                pageNumber,
                filter: filterCriteria
            }
        })
        .then(result => result.data);
    };
}



// WEBPACK FOOTER //
// ./Client/app/dealer/services/list/getDealersListByNumber.js